export default __webpack_public_path__ + "static/media/Member_SunYi.55744fca.jpg";